var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 14.699L13.4572 11.3887C13.3078 11.2393 13.1053 11.1562 12.8928 11.1562H12.3516C13.268 9.98418 13.8125 8.50996 13.8125 6.90625C13.8125 3.09121 10.7213 0 6.90625 0C3.09121 0 0 3.09121 0 6.90625C0 10.7213 3.09121 13.8125 6.90625 13.8125C8.50996 13.8125 9.98418 13.268 11.1562 12.3516V12.8928C11.1562 13.1053 11.2393 13.3078 11.3887 13.4572L14.699 16.7676C15.0111 17.0797 15.5158 17.0797 15.8246 16.7676L16.7643 15.8279C17.0764 15.5158 17.0764 15.0111 16.7676 14.699ZM6.90625 11.1562C4.55879 11.1562 2.65625 9.25703 2.65625 6.90625C2.65625 4.55879 4.55547 2.65625 6.90625 2.65625C9.25371 2.65625 11.1562 4.55547 11.1562 6.90625C11.1562 9.25371 9.25703 11.1562 6.90625 11.1562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.d1448698193482b65baa3a34b9c786a5.svg";
export { ForwardRef as ReactComponent };